var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:_vm.customClass,attrs:{"color":_vm.colorString,"type":"submit","disabled":_vm.disabledButton,"text":_vm.flat}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }